import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class EmployeeJobBreakService {
  private apiUrl = environment.baseUrl + '/wfm/job-break';

  constructor(private http: HttpClient) { }

  getBreaks(employeeId: number): Observable<any> {
    return this.http.get(`${this.apiUrl}/getList?employee_id=${employeeId}`);
  }

  saveBreak(data: any): Observable<any> {
    return this.http.post(`${this.apiUrl}/save`, data);
  }

  deleteBreak(id: number): Observable<any> {
    return this.http.post(`${this.apiUrl}/delete`, { id });
  }

  getLeaveTypes(): Observable<any> {
    return this.http.get(`${this.apiUrl}/getLeaveTypes`);
  }
}
